module.exports = new __parcel__URL__("buy_one_button.a275bdbe.png").toString();